export function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function normalizeName(name: string): string {
  return name.trim().toLocaleLowerCase()
}

export function getTextClass(type: 'h1' | 'h2' | 'h3' | 'h4' | 'regular' | 'small' | 'big' | 'nav' | 'btn') {
  // use array-style to support tailwind-merge
  return [
    'text-new-grey-4 tracking-normal normal-case',

    type === 'h1' && 'text-new-2xl',
    type === 'h2' && 'text-new-xl',
    type === 'big' && 'text-new-lg',
    ['h3', 'h4', 'regular', 'nav', 'btn'].includes(type) && 'text-new-base',
    type === 'small' && 'text-new-sm',

    ['h3', 'h4'].includes(type) && 'font-semi-bold',
    type === 'small' && 'font-light',

    ['h4', 'nav'].includes(type) && 'tracking-[0.12em]', // 12%
    type === 'btn' && 'tracking-[0.08em]', // 8%
  ]
}
